import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSections } from './ProblemSections';
import { RoofSection } from './RoofSection';
import { KitSection } from './KitSection';
import { OfferSection } from './OfferSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0F0E0C] text-[#E8E0D4] font-sans selection:bg-[#C4956A]/30 selection:text-[#E8E0D4]" data-id="element-208">
      <style data-id="element-209">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500&family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap');
          
          body {
            background-color: #0F0E0C;
          }
        `}
      </style>

      <div className="w-full overflow-hidden" data-id="element-210">
        <HeroSection data-id="element-211" />

        <div className="relative" data-id="element-212">
          {/* Subtle background gradient line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-[#C4956A]/10 to-transparent pointer-events-none" data-id="element-213"></div>

          <ProblemSections data-id="element-214" />
          <RoofSection data-id="element-215" />
          <KitSection data-id="element-216" />
          <OfferSection data-id="element-217" />
        </div>

        <footer className="py-12 text-center text-[#9B9285]/40 text-sm border-t border-[#C4956A]/5" data-id="element-218">
          <p data-id="element-219">© {new Date().getFullYear()} R.O.O.F. Anxiety Kit</p>
        </footer>
      </div>
    </main>;
}